import { render } from "./BrandWoche.vue?vue&type=template&id=5e69050e"
import script from "./BrandWoche.vue?vue&type=script&lang=ts"
export * from "./BrandWoche.vue?vue&type=script&lang=ts"

import "./BrandWoche.vue?vue&type=style&index=0&id=5e69050e&lang=scss"
script.render = render

export default script